import moment from 'moment';
import Attachment from '../models/Attachment';
import Comment from '../models/Comment';

/** Match legacy intake files created near the message (ms). */
export const LEGACY_FORWARD_ATTACHMENT_WINDOW_MS = 10_000;

const changeIdOf = (attachment: Attachment, changeId: string) =>
    String(attachment.change?._id || attachment.change || '') === String(changeId);

/**
 * Attachments for a timeline message: linked via `comment`, else legacy
 * unlinked change files created within a short window of the message.
 */
export function attachmentsForForwardedComment(
    attachments: Attachment[],
    changeId: string,
    comment: Comment,
): Attachment[] {
    const list = Array.isArray(attachments) ? attachments : [];
    const linked = list.filter(
        (attachment) => changeIdOf(attachment, changeId) && attachment.comment === comment._id,
    );
    if (linked.length)
        return linked;

    const createdAt = comment.createdAt;
    if (!createdAt || !moment.isMoment(createdAt))
        return [];

    const t = createdAt.valueOf();
    return list.filter((attachment) => {
        if (!changeIdOf(attachment, changeId) || attachment.comment)
            return false;
        if (!attachment.createdAt || !moment.isMoment(attachment.createdAt))
            return false;
        return Math.abs(attachment.createdAt.valueOf() - t) <= LEGACY_FORWARD_ATTACHMENT_WINDOW_MS;
    });
}

const escapeHtml = (value: string) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

/** HTML block listing download links for the forward quote / outbound body. */
export function buildForwardAttachmentsHtml(
    attachments: Attachment[],
    label = 'Pièces jointes :',
): string {
    if (!attachments.length)
        return '';
    const items = attachments.map((attachment) => {
        const name = String(attachment.name || attachment._id);
        return `<li><a href="${attachment.downloadUrl()}">${escapeHtml(name)}</a></li>`;
    }).join('');
    return `<div class="yoda-forward-attachments"><p><strong>${escapeHtml(label)}</strong></p><ul>${items}</ul></div>`;
}
